var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 185.01 185.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: .23px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #c9c9c9;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #cc0202;\n        stroke-width: .23px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.11,
    y: 172.58,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.11,
    y: 135.62,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.11,
    y: 123.3,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.11,
    y: 49.39,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.11,
    y: 37.07,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.11,
    y: 0.11,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.43,
    y: 160.26,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.43,
    y: 135.62,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.43,
    y: 86.35,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.43,
    y: 37.07,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.43,
    y: 12.43,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.75,
    y: 147.94,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.75,
    y: 135.62,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.75,
    y: 110.98,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.75,
    y: 98.66,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.75,
    y: 74.03,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.75,
    y: 61.71,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.75,
    y: 37.07,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.75,
    y: 24.75,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 37.07,
    y: 172.58,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 37.07,
    y: 160.26,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 37.07,
    y: 147.94,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 37.07,
    y: 135.62,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.07,
    y: 110.98,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.07,
    y: 61.71,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 37.07,
    y: 37.07,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 37.07,
    y: 24.75,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 37.07,
    y: 12.43,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 37.07,
    y: 0.11,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 49.39,
    y: 172.58,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.39,
    y: 123.3,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.39,
    y: 110.98,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.39,
    y: 61.71,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.39,
    y: 49.39,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 49.39,
    y: 0.11,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 61.71,
    y: 147.94,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 61.71,
    y: 135.62,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 61.71,
    y: 123.3,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 61.71,
    y: 110.98,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 61.71,
    y: 86.35,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 61.71,
    y: 61.71,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 61.71,
    y: 49.39,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 61.71,
    y: 37.07,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 61.71,
    y: 24.75,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.03,
    y: 147.94,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 74.03,
    y: 98.66,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 74.03,
    y: 86.35,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 74.03,
    y: 74.03,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.03,
    y: 24.75,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 86.35,
    y: 160.26,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 86.35,
    y: 110.98,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 86.35,
    y: 98.66,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 86.35,
    y: 86.35,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 86.35,
    y: 74.03,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 86.35,
    y: 61.71,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 86.35,
    y: 12.43,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 172.58,
    y: 0.11,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 172.58,
    y: 37.07,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 172.58,
    y: 49.39,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 172.58,
    y: 123.3,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 172.58,
    y: 135.62,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 172.58,
    y: 172.58,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 160.26,
    y: 12.43,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 160.26,
    y: 37.07,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 160.26,
    y: 86.35,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 160.26,
    y: 135.62,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 160.26,
    y: 160.26,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 147.94,
    y: 24.75,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 147.94,
    y: 37.07,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 147.94,
    y: 61.71,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 147.94,
    y: 74.03,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 147.94,
    y: 98.66,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 147.94,
    y: 110.98,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 147.94,
    y: 135.62,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 147.94,
    y: 147.94,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 135.62,
    y: 0.11,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 135.62,
    y: 12.43,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 135.62,
    y: 24.75,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 135.62,
    y: 37.07,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 135.62,
    y: 61.71,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 135.62,
    y: 110.98,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 135.62,
    y: 135.62,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 135.62,
    y: 147.94,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 135.62,
    y: 160.26,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 135.62,
    y: 172.58,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.3,
    y: 0.11,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 123.3,
    y: 49.39,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 123.3,
    y: 61.71,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 123.3,
    y: 110.98,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 123.3,
    y: 123.3,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.3,
    y: 172.58,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.98,
    y: 24.75,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.98,
    y: 37.07,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.98,
    y: 49.39,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.98,
    y: 61.71,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 110.98,
    y: 86.35,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.98,
    y: 110.98,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.98,
    y: 123.3,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.98,
    y: 135.62,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.98,
    y: 147.94,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 98.66,
    y: 24.75,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 98.66,
    y: 74.03,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 98.66,
    y: 86.35,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 98.66,
    y: 98.66,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 98.66,
    y: 147.94,
    width: 12.32,
    height: 12.32
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset9);
export default __webpack_public_path__ + "static/media/Asset9.bc93070ebf788568f8c6b8e5da623a3d.svg";
export { ForwardRef as ReactComponent };